<template>
	<div style="background-color: #eee">

		<v-overlay :value="aggiornandoEsito || isLoadingCompensi">
			<v-progress-circular
				indeterminate
				size="64"
				color="whites"
			></v-progress-circular>
		</v-overlay>

		<v-row>
			<v-col class="d-flex justify-space-between align-center" cols="12">
				<v-btn
					style="text-transform:none; letter-spacing:0.5px;"
					:color="scdColor"
					class="_semi_bold white--text mr-2"
					@click="openFiltersDialog()"
					:disabled="isLoadingCompensi || aggiornandoEsito"
				>
					Filtri
				</v-btn>
				
				<v-btn
					v-if="compensiSelezionati.length > 0"
					:color="scdColor"
					class="white--text mr-2"
					@click="apriDialogModificaEsitoClickdayDeiCompensiSelezionati"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
				
				<v-text-field
					label="Cerca"
					v-model="search"
					append-icon="mdi-magnify"
					single-line
					outlined
					hide-details
					dense
					class="mr-2"
				></v-text-field>
				
				<v-select
					item-text="nome"
					item-value="id"
					:items="bandi"
					v-model="bandoId"
					placeholder="Bando"
					@change="getCompensi()"
					:disabled="isLoadingBando"
					:loading="isLoadingBando"
					outlined
					dense
					class="mr-2 bando-select"
					hide-details
				></v-select>
				
				<v-btn
					:color="scdColor"
					class="white--text mr-2"
					@click="downloadCsv()"
				>
					Scarica CSV
				</v-btn>
				
				<v-btn
					v-if="computedAmIAdmin"
					:color="scdColor"
					class="white--text mr-2"
					@click="apriDialogScaricaPdfs('path_ricevuta_o_fattura')"
				>
					Scarica PDF provvisori
				</v-btn>
				
				<v-btn
					v-if="computedAmIAdmin"
					:color="scdColor"
					class="white--text mr-2"
					@click="apriDialogScaricaPdfs('path_ricevuta_o_fattura_esiti_definitivi')"
				>
					Scarica PDF definitivi
				</v-btn>
			</v-col>
			
			<v-col
				cols="12"
				style="font-size: 12px"
				class="d-flex pt-0"
			>
				<div class="mr-6">
					<span class="font-weight-medium mr-1">Totale Compensi Esiti Provvisori:</span>
					<span class="font-weight-medium" :style="`color:${scdColorStrong}`">{{ sommaCompensiEsitiProvvisori }} €</span>
				</div>
				<div class="mr-6">
					<span class="font-weight-medium mr-1">Totale Compensi Esiti Definitivi:</span>
					<span class="font-weight-medium" :style="`color:${scdColorStrong}`">{{ sommaCompensiEsitiDefinitivi }} €</span>
				</div>
				<div class="mr-6">
					<span class="font-weight-medium mr-1">Somma Differenza Compensi:</span>
					<span class="font-weight-medium" :style="`color:${scdColorStrong}`">{{ sommaDifferenzaCompensi }} €</span>
				</div>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<v-data-table
					v-model="compensiSelezionati"
					:headers="headersToShow"
					:items="compensi"
					item-key="id"
					:show-select="computedAmIAdmin"
					loading-text="In caricamento.."
					:loading="isLoadingCompensi"
					:search="search"
					no-data-text="Nessun cliccatore"
					:options="{ itemsPerPage: -1 }"
					:footer-props="{
						'items-per-page-options':[-1, -1],
						'items-per-page-text': 'Cliccatori per pagina'
					}"
					style="background-color: white; border-radius: 0"
					class="compensi-data-table"
					dense
					fixed-header
					height="calc(100vh - 315px)"
				>
					<template v-slot:item.data_bonifico="{ item }">
						{{ dateITFormatDDMMYYYY(item.data_bonifico) }}
					</template>
					
					<template v-slot:item.ricevuta_o_fattura="{ item }">
						<v-btn
							color="primary"
							rounded
							x-small
							class="white--text"
							:disabled="item.path_ricevuta_o_fattura === null"
							:loading="item.isGettingRicevutaOFattura"
							@click="apriRicevutaOFatturaInUnaNuovaSchedaDelBrowser(item)"
						>
							Visualizza
						</v-btn>
					</template>
					
					<template v-slot:item.ricevuta_o_fattura_esiti_definitivi="{ item }">
						<v-btn
							color="primary"
							rounded
							x-small
							class="white--text"
							:disabled="item.path_ricevuta_o_fattura_esiti_definitivi === null"
							:loading="item.isGettingRicevutaOFatturaEsitiDefinitivi"
							@click="apriRicevutaOFatturaEsitiDefinitiviInUnaNuovaSchedaDelBrowser(item)"
						>
							Visualizza
						</v-btn>
					</template>
					
					<template v-slot:item.residenza_estera="{ item }">
						{{ item.residenza_estera ? 'Si' : 'No' }}
					</template>
					
					<template v-slot:item.possesso_partita_iva="{ item }">
						{{ item.possesso_partita_iva ? 'Si' : 'No' }}
					</template>
					
					<template v-slot:item.dati_inseriti="{ item }">
						{{ item.dati_inseriti ? 'Si' : 'No' }}
					</template>
					
					<template v-slot:item.data_di_nascita="{ item }">
						{{ dateITFormatDDMMYYYY(item.data_di_nascita) }}
					</template>
					
					<template v-slot:item.codice_fiscale_manuale="{ item }">
						{{ item.codice_fiscale_manuale ? 'Si' : 'No' }}
					</template>
					
					<template v-slot:item.azioni="{ item }">
						<v-icon
							:color="scdColor"
							@click="apriDialogModificaEsitoClickday(item)"
							small
							class="mr-1"
						>
							edit
						</v-icon>
						
						<v-icon
							:color="scdColor"
							@click="apriDialogDatiDiFatturazione(item)"
							small
						>
							mdi-currency-eur
						</v-icon>
					</template>
					
					<template v-slot:footer.prepend>
						<div class="d-flex align-center">
							<v-btn
								@click="showHeadersDialog = true"
								color="primary"
								class="ml-md-auto mr-3 white--text"
							>
								<v-icon small>mdi-minus</v-icon>
								<v-icon>mdi-view-column-outline</v-icon>
								<v-icon small>mdi-plus</v-icon>
							</v-btn>
						</div>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		
		<v-dialog
			v-model="dialogDatiDiFatturazione"
			persistent
			scrollable
			width="1000px"
		>
			<dati-di-fatturazione-component
				:key="dialogDatiDiFatturazioneKey"
				:value="datiCliccatorePerDatiDiFatturazione"
				:id-cliccatore="idCliccatorePerDatiDiFatturazione"
				:bando-id="bandoId"
				@close="dialogDatiDiFatturazione = false"
				@salvataggio-eseguito="aggiornaCompensi()"
			></dati-di-fatturazione-component>
		</v-dialog>

		<v-dialog
			v-model="mostraDialogModificaEsitoClickday"
			max-width="580"
			persistent
		>
			<modifica-esito-clickday-component
				:key="modificaEsitoKey"
				:dati-esito-clickday="datiModificaEsitoClickday"
				:bando-id="bandoId"
				@dati-esito-clickday-aggiornati="aggiornaCompensi()"
				@chiudi-dialog="mostraDialogModificaEsitoClickday = false"
			></modifica-esito-clickday-component>
		</v-dialog>
		
		<v-dialog
			v-model="mostraDialogModificaEsitoClickdayDeiCompensiSelezionati"
			max-width="580"
			persistent
		>
			<modifica-esito-clickday-component
				:key="modificaEsitoDeiCompensiSelezionatiKey"
				:dati-esito-clickday="datiModificaEsitoClickdayDeiCompensiSelezionati"
				:bando-id="bandoId"
				:modifica-di-massa="true"
				@dati-esito-clickday-aggiornati="aggiornaCompensi()"
				@chiudi-dialog="mostraDialogModificaEsitoClickdayDeiCompensiSelezionati = false"
			></modifica-esito-clickday-component>
		</v-dialog>
		
		<v-dialog v-model="filtersDialog" width="800">
			<v-card>
				<v-card-title>
					<span class="primary--text">Filtri</span>
				</v-card-title>
				<v-card-text>
					<v-row class="mt-1">
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="opzioniStatoPagamentoCompenso"
								v-model="filters.statoPagamento"
								label="Stato Pagamento"
								clearable
								multiple
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="['ricevuta o fattura caricati', 'ricevuta o fattura non caricati']"
								v-model="filters.statoRicevutaOFatturaEsitiProvvisori"
								label="Stato Ricevuta o Fattura Esiti Provvisori"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="['ricevuta o fattura caricati', 'ricevuta o fattura non caricati']"
								v-model="filters.statoRicevutaOFatturaEsitiDefinitivi"
								label="Stato Ricevuta o Fattura Esiti Definitivi"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="['compenso > 0', 'compenso <= 0']"
								v-model="filters.compensoEsitiProvvisori"
								label="Compenso Esiti Provvisori"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="['compenso > 0', 'compenso <= 0']"
								v-model="filters.compensoEsitiDefinitivi"
								label="Compenso Esiti Definitivi"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="['differenza compensi > 0', 'differenza compensi <= 0']"
								v-model="filters.differenzaCompensi"
								label="Differenza Compensi"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="opzioniEsitoClickday"
								v-model="filters.esitoClickday"
								label="Esito Click Day"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="[{ text: 'Si', value: true }, { text: 'No', value: false }]"
								v-model="filters.residenzaEstera"
								label="Residenza Estera"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="[{ text: 'Si', value: true }, { text: 'No', value: false }]"
								v-model="filters.possessoPartitaIva"
								label="Possesso Partita IVA"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="[{ text: 'Si', value: true }, { text: 'No', value: false }]"
								v-model="filters.datiInseriti"
								label="Dati di Fatturazione Inseriti"
								clearable
							>
							</v-select>
						</v-col>
						
						<v-col v-if="computedAmIAdmin" cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="teams"
								item-text="nome"
								item-value="nome"
								v-model="filters.teamName"
								label="Squadra"
								clearable
								:loading="isLoadingTeams"
							>
							</v-select>
						</v-col>
						
						<v-col cols="6" class="py-0">
							<v-select
								outlined
								dense
								:items="['Si', 'No']"
								v-model="filters.noteCompensoInserite"
								label="Note Compenso Inserite"
								clearable
							>
							</v-select>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						style="text-transform:none; letter-spacing:0.5px;"
						:color="scdColor"
						class="white--text"
						@click="filtersDialog = false"
					>
						Chiudi
					</v-btn>
					<v-btn
						style="text-transform:none; letter-spacing:0.5px;"
						:color="scdOrange"
						class="white--text"
						@click="applyFilters()"
					>
						Filtra
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="showHeadersDialog"
			width="unset"
		>
			<v-card>
				<v-card-title>
					<span class="mr-1">Mostra/nascondi colonne</span>
					<v-spacer></v-spacer>
					<v-icon @click="showHeadersDialog = false">mdi-close</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet
						outlined
						rounded
						class="py-3"
					>
						<v-treeview
							:items="headersToFilter"
							item-key="value"
							item-text="text"
							v-model="selectedHeaders"
							selected-color="primary"
							selectable
							dense
							open-all
						>
						</v-treeview>
					</v-sheet>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="downloadPdfsDialog"
			width="unset"
			persistent
		>
			<v-card>
				<v-card-title>
					<span>{{ downloadPdfsDialogTitle }}</span>
				</v-card-title>
				<v-card-text>
					<template v-if="!downloadingPdfs && !downloadEnded">
						Il processo potrebbe richiedere qualche minuto, vuoi continuare?
					</template>
					
					<template v-if="cancelDownload && !downloadCancelled">
						<div class="error--text font-weight-bold mb-2">
							L'annullamento avverrà a breve
						</div>
					</template>
					
					<v-progress-linear
						v-if="downloadingPdfs || downloadEnded"
						:value="downloadPdfsProgress"
						height="20"
						:color="downloadPdfProgressLinearColor"
						:indeterminate="loadingTotalZips"
					>
						<template v-slot:default>
							<strong>
								<template v-if="loadingTotalZips">
									Preparazione...
								</template>
								<template v-else-if="zeroZips">
									Non ci sono Ricevute o Fatture da scaricare
								</template>
								<template v-else-if="downloadingPdfs">
									Scaricamento {{ totalZips !== 1 ? `parte ${ currentZip } di ${ totalZips } ` : '' }}file zip
								</template>
								<template v-else-if="downloadCompleted">
									Scaricamento completato
								</template>
								<template v-else-if="downloadCancelled">
									Scaricamento annullato
								</template>
							</strong>
						</template>
					</v-progress-linear>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="!downloadEnded && !downloadingPdfs"
						color="primary"
						@click="downloadPdfsDialog = false"
						:disabled="downloadingPdfs"
					>
						Chiudi
					</v-btn>
					<!-- NOTA: non ha senso annullare il download quando sta già scaricando l'ultimo zip -->
					<v-btn
						v-if="downloadingPdfs && (currentZip != totalZips)"
						color="error"
						@click="cancelDownload = true"
						:disabled="cancelDownload"
					>
						Annulla
					</v-btn>
					<v-btn
						v-if="!downloadEnded"
						color="secondary"
						@click="startDownload(DBColumnName)"
						:disabled="downloadingPdfs"
					>
						Scarica
					</v-btn>
					<v-btn
						v-if="downloadEnded || zeroZips"
						color="secondary"
						@click="resetDownloadPdfs()"
					>
						Ok
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isLoadingCompensi: false,
			headers: [
				{ text: 'Codice', value: 'codice_cliccatore' },
				{ text: 'Cliccatore', value: 'username' },
				{ text: 'Email', value: 'email' },
				{ text: 'Nome', value: 'nome_in_dati_di_fatturazione' },
				{ text: 'Cognome', value: 'cognome_in_dati_di_fatturazione' },
				{ text: 'Cellulare', value: 'cellulare' },
				{ text: 'Squadra', value: 'nome_squadra' },
				{ text: 'Tempo', value: 'tempo_clickday' },
				{ text: 'Esito', value: 'esito_clickday' },
				
				{ text: 'Compenso Esiti Provvisori', value: 'compenso_finale_esiti_provvisori' },
				{ text: 'Compenso Esiti Definitivi', value: 'compenso_finale_esiti_definitivi' },
				{ text: 'Differenza compensi', value: 'differenza_compensi_finali' },
				{ text: 'Ricevuta o Fattura Esiti Provvisori', value: 'ricevuta_o_fattura' },
				{ text: 'Ricevuta o Fattura Esiti Definitivi', value: 'ricevuta_o_fattura_esiti_definitivi' },
				{ text: 'Data Bonifico', value: 'data_bonifico' },
				{ text: 'Stato pagamento', value: 'stato_pagamento_compenso' },
				{ text: 'Note compenso', value: 'note_compenso' },
				
				{ text: 'Residenza Estera', value: 'residenza_estera' },
				{ text: 'Possesso Partita IVA', value: 'possesso_partita_iva' },
				{ text: 'Sesso', value: 'sesso' },
				{ text: 'Comune di nascita', value: 'luogo_di_nascita' },
				{ text: 'Sigla provincia di nascita', value: 'sigla_provincia_di_nascita' },
				{ text: 'Data di nascita', value: 'data_di_nascita' },
				{ text: 'Codice Fiscale', value: 'codice_fiscale' },
				{ text: 'Codice Fiscale Manuale', value: 'codice_fiscale_manuale' },
				{ text: 'Partita IVA', value: 'partita_iva' },
				{ text: 'Ragione Sociale', value: 'ragione_sociale' },
				{ text: 'Via', value: 'via' },
				{ text: 'Numero civico', value: 'numero_civico' },
				{ text: 'Comune di residenza', value: 'comune' },
				{ text: 'CAP', value: 'cap' },
				{ text: 'Provincia', value: 'provincia' },
				{ text: 'Sigla provincia di residenza', value: 'sigla_provincia' },
				{ text: 'Stato estero', value: 'stato_estero' },
				{ text: 'IBAN', value: 'iban' },
				{ text: 'Intestatario IBAN', value: 'intestatario_iban' },
				{ text: 'Dati di Fatturazione inseriti', value: 'dati_inseriti' },
				
				// { text: 'CF o PIVA', value: 'cf_o_piva' },
				
				{ text: 'Azioni', value: 'azioni', width: '73px' },
			],
			compensi: [],
			sommaCompensiEsitiProvvisori: null,
			sommaCompensiEsitiDefinitivi: null,
			sommaDifferenzaCompensi: null,
			
			search: null,
			
			isLoadingBando: false,
			bandi: [],
			bandoId: null,

			modificaEsitoKey: 0,
			datiModificaEsitoClickday: {
				idCliccatore: null,
				esitoClickday: null,
				tempoClickday: null,
				compensoFinalePersonalizzatoEsitiProvvisori: null,
				compensoFinalePersonalizzatoEsitiDefinitivi: null,
				noteCompenso: null,
				statoPagamentoCompenso: null,
				dataDelBonifico: null,
				codiceCliccatore: null,
				nomeInDatiDiFatturazione: null,
				cognomeInDatiDiFatturazione: null
			},
			mostraDialogModificaEsitoClickday: false,
			aggiornandoEsito: false,
			
			modificaEsitoDeiCompensiSelezionatiKey: 0,
			datiModificaEsitoClickdayDeiCompensiSelezionati: {
				idsCliccatori: null,
				esitoClickday: null,
				noteCompenso: null,
				statoPagamentoCompenso: null,
				dataDelBonifico: null,
				codiceCliccatore: null,
				nomeInDatiDiFatturazione: null,
				cognomeInDatiDiFatturazione: null
			},
			mostraDialogModificaEsitoClickdayDeiCompensiSelezionati: false,
			
			isLoadingTeams: false,
			teams: [],
			
			filtersDialog: false,
			filters: {
				statoIban: null,
				statoIntestatarioIban: null,
				statoPagamento: null,
				statoCFPIVA: null,
				statoRicevutaOFatturaEsitiProvvisori: null,
				statoRicevutaOFatturaEsitiDefinitivi: null,
				compensoEsitiProvvisori: null,
				compensoEsitiDefinitivi: null,
				differenzaCompensi: null,
				teamName: null,
				esitoClickday: null,
				residenzaEstera: null,
				possessoPartitaIva: null,
				datiInseriti: null,
				noteCompensoInserite: null
			},
			appliedFilters: {
				statoIban: null,
				statoIntestatarioIban: null,
				statoPagamento: null,
				statoCFPIVA: null,
				statoRicevutaOFatturaEsitiProvvisori: null,
				statoRicevutaOFatturaEsitiDefinitivi: null,
				compensoEsitiProvvisori: null,
				compensoEsitiDefinitivi: null,
				differenzaCompensi: null,
				teamName: null,
				esitoClickday: null,
				residenzaEstera: null,
				possessoPartitaIva: null,
				datiInseriti: null,
				noteCompensoInserite: null
			},
			
			showHeadersDialog: false,
			selectedHeaders: [],
			
			compensiSelezionati: [],
			
			dialogDatiDiFatturazioneKey: 0,
			dialogDatiDiFatturazione: false,
			datiCliccatorePerDatiDiFatturazione: null,
			idCliccatorePerDatiDiFatturazione: null,
			
			opzioniEsitoClickday: [],
			opzioniStatoPagamentoCompenso: [],
			
			downloadPdfsDialog: false,
			downloadPdfsDialogTitle: null,
			DBColumnName: null,
			loadingTotalZips: false,
			totalZips: 0,
			zeroZips: false,
			currentZip: 0,
			downloadPdfsProgress: 0,
			downloadingPdfs: false,
			downloadCompleted: false,
			cancelDownload: false,
			downloadCancelled: false,
			downloadEnded: false // indica se il metodo startDownload è giunto alla fine, a prescindere se il download è stato completato o no
		}
	},

	created() {
		if (localStorage.getItem('selected_compensi_headers_simulatore_clickday')) {
			this.selectedHeaders = JSON.parse(localStorage.getItem('selected_compensi_headers_simulatore_clickday'));
		}
		else {
			this.selectedHeaders = this.headers.map(header => (header.value));
			localStorage.setItem('selected_compensi_headers_simulatore_clickday', JSON.stringify(this.selectedHeaders));
		}
		
		this.getOpzioni();
		this.getBandi();
		this.bandoId = this.computedBandoId;
		this.getCompensi();
	},
	
	watch: {
		selectedHeaders(newHeaders, oldHeaders) {
			localStorage.setItem('selected_compensi_headers_simulatore_clickday', JSON.stringify(newHeaders));
		}
	},
	
	computed: {
		headersToFilter() {
			return [{
				value: 'headers',
				text: 'Tutte',
				children: this.headers.flatMap(header => {
					if (header.value !== 'actions') {
						return {
							value: header.value,
							text: header.text
						}
					}
					else return [];
				})
			}]
		},
		headersToShow() {
			return this.headers.filter(header => this.selectedHeaders.includes(header.value) || header.value == 'actions')
		},
		downloadPdfProgressLinearColor() {
			if (this.downloadCompleted && !this.zeroZips) return 'success'
			if (this.downloadCancelled && !this.zeroZips) return 'error'
			else if (this.zeroZips) return 'warning'
			else return 'secondary'
		}
	},

	methods: {
		getCompensi() {
			this.isLoadingCompensi = true;
			axios.get(`/cliccatori/compensi/${this.bandoId}`, {
				params: {
					statoIban: this.appliedFilters.statoIban,
					statoIntestatarioIban: this.appliedFilters.statoIntestatarioIban,
					statoPagamento: this.appliedFilters.statoPagamento,
					statoCFPIVA: this.appliedFilters.statoCFPIVA,
					statoRicevutaOFatturaEsitiProvvisori: this.appliedFilters.statoRicevutaOFatturaEsitiProvvisori,
					statoRicevutaOFatturaEsitiDefinitivi: this.appliedFilters.statoRicevutaOFatturaEsitiDefinitivi,
					compensoEsitiProvvisori: this.appliedFilters.compensoEsitiProvvisori,
					compensoEsitiDefinitivi: this.appliedFilters.compensoEsitiDefinitivi,
					differenzaCompensi: this.appliedFilters.differenzaCompensi,
					teamName: this.appliedFilters.teamName,
					esitoClickday: this.appliedFilters.esitoClickday,
					residenzaEstera: this.appliedFilters.residenzaEstera,
					possessoPartitaIva: this.appliedFilters.possessoPartitaIva,
					datiInseriti: this.appliedFilters.datiInseriti,
					noteCompensoInserite: this.appliedFilters.noteCompensoInserite
				}
			})
				.then(response => {
					this.compensi = response.data.compensi;
					this.compensi.forEach(item => {
						this.$set(item, "isGettingRicevutaOFattura", false); // reactive
						this.$set(item, "isGettingRicevutaOFatturaEsitiDefinitivi", false); // reactive
					})
					
					this.sommaCompensiEsitiProvvisori = response.data.somma_compensi_esiti_provvisori;
					this.sommaCompensiEsitiDefinitivi = response.data.somma_compensi_esiti_definitivi;
					this.sommaDifferenzaCompensi = response.data.somma_differenza_compensi;
				})
				.finally(() => {
					this.isLoadingCompensi = false;
				})
		},
		getBandi() {
			this.isLoadingBando = true;
			axios.get('/getBandi')
				.then(response => {
					this.bandi = response.data.bandi;
				})
				.finally(() => {
					this.isLoadingBando = false;
				})
		},
		downloadCsv() {
			// aggiungo le parentesi tonde altrimenti excel converte il tempo in decimale
			this.compensi.forEach(x => {
				x.tempo_clickday = '(' + x.tempo_clickday + ')';
			})
			let csv = this.$papa.unparse(this.compensi, {
				delimiter: ";",
				header: true,
				columns: [
					'username',
					'email',
					'nome_squadra',
					'tempo_clickday',
					'esito_clickday',
					'compenso_finale_esiti_provvisori',
					'compenso_finale_esiti_definitivi',
					'iban',
					'intestatario_iban',
					'stato_pagamento_compenso',
					'note_compenso'
				]
			});

			this.$papa.download(csv, 'compensi_cliccatori')
		},
		apriDialogModificaEsitoClickday(datiCliccatore) {
			this.datiModificaEsitoClickday = {
				idCliccatore: datiCliccatore.id,
				esitoClickday: datiCliccatore.esito_clickday,
				tempoClickday: datiCliccatore.tempo_clickday,
				// totaleCompensoVittoria: datiCliccatore.totale_compenso_vittoria,
				// totaleCompensoPerdita: datiCliccatore.totale_compenso_perdita,
				compensoFinalePersonalizzatoEsitiProvvisori: datiCliccatore.compenso_finale_personalizzato_esiti_provvisori !== null
					? datiCliccatore.compenso_finale_personalizzato_esiti_provvisori
					: null,
				compensoFinalePersonalizzatoEsitiDefinitivi: datiCliccatore.compenso_finale_personalizzato_esiti_definitivi !== null
					? datiCliccatore.compenso_finale_personalizzato_esiti_definitivi
					: null,
				statoPagamentoCompenso: datiCliccatore.stato_pagamento_compenso,
				noteCompenso: datiCliccatore.note_compenso,
				dataDelBonifico: datiCliccatore.data_bonifico,
				codiceCliccatore: datiCliccatore.codice_cliccatore,
				nomeCliccatore: datiCliccatore.nome_in_dati_di_fatturazione,
				cognomeCliccatore: datiCliccatore.cognome_in_dati_di_fatturazione
			}
			
			this.modificaEsitoKey++;
			this.mostraDialogModificaEsitoClickday = true;
		},
		apriDialogModificaEsitoClickdayDeiCompensiSelezionati() {
			this.modificaEsitoDeiCompensiSelezionatiKey++;
			this.datiModificaEsitoClickdayDeiCompensiSelezionati.idsCliccatori = this.compensiSelezionati.map(c => c['id']);
			this.mostraDialogModificaEsitoClickdayDeiCompensiSelezionati = true;
		},
		// faccio così per non ricaricare la tabella e far perdere il segno a chi sta modificando gli esiti
		async aggiornaCompensi() {
			this.aggiornandoEsito = true;
			await this.getCompensi();
			this.aggiornandoEsito = false;
		},
		apriRicevutaOFatturaInUnaNuovaSchedaDelBrowser(item) {
			item.isGettingRicevutaOFattura = true;
			axios.post('/cliccatori/get-ricevuta-o-fattura', {
				path_ricevuta_o_fattura: item.path_ricevuta_o_fattura
			}, {
				responseType: 'arraybuffer'
			})
				.then(response => {
					// this.ricevutaPdf = response.data;
					const file = new Blob([response.data], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
				})
				.finally(() => {
					item.isGettingRicevutaOFattura = false;
				})
		},
		apriRicevutaOFatturaEsitiDefinitiviInUnaNuovaSchedaDelBrowser(item) {
			item.isGettingRicevutaOFatturaEsitiDefinitivi = true;
			axios.post('/cliccatori/get-ricevuta-o-fattura-esiti-definitivi', {
				path_ricevuta_o_fattura_esiti_definitivi: item.path_ricevuta_o_fattura_esiti_definitivi
			}, {
				responseType: 'arraybuffer'
			})
				.then(response => {
					// this.ricevutaPdf = response.data;
					const file = new Blob([response.data], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
				})
				.finally(() => {
					item.isGettingRicevutaOFatturaEsitiDefinitivi = false;
				})
		},
		openFiltersDialog() {
			this.filtersDialog = true;
			this.getTeams();
		},
		applyFilters() {
			for (const key in this.filters) {
				this.appliedFilters[key] = this.filters[key];
			}
			this.getCompensi();
			this.filtersDialog = false;
		},
		getTeams: function(indexTeamSelezionato) {
			this.isLoadingTeams = true;
			
			return axios.get("/teams")
				.then(response => {
					this.teams = response.data.data;
				})
				.finally(() => {
					this.isLoadingTeams = false;
				});
		},
		apriDialogDatiDiFatturazione(cliccatore) {
			this.dialogDatiDiFatturazioneKey++;
			this.datiCliccatorePerDatiDiFatturazione = cliccatore;
			this.idCliccatorePerDatiDiFatturazione = cliccatore.id;
			this.dialogDatiDiFatturazione = true;
		},
		getOpzioni() {
			return axios.get('/clickdayit/opzioni-modifica-esito')
				.then(response => {
					this.opzioniStatoPagamentoCompenso = response.data.opzioni_stato_pagamento_compenso;
					this.opzioniEsitoClickday = response.data.opzioni_esito_clickday;
				})
		},
		apriDialogScaricaPdfs(DBColumnName) {
			this.downloadPdfsDialog = true;
			
			this.DBColumnName = DBColumnName;
			
			if (DBColumnName == 'path_ricevuta_o_fattura')
				this.downloadPdfsDialogTitle = 'Scarica Ricevute e Fatture Esiti Provvisori';
			else if (DBColumnName == 'path_ricevuta_o_fattura_esiti_definitivi')
				this.downloadPdfsDialogTitle = 'Scarica Ricevute e Fatture Esiti Definitivi';
		},
		async startDownload(DBColumnName) {
			this.downloadingPdfs = true;
			this.esitiNameByDBColumnName = DBColumnName == 'path_ricevuta_o_fattura' ? 'Provvisori' : 'Definitivi';
			
			try {
				// Ottieni il numero totale di ZIP
				this.loadingTotalZips = true;
				const response = await axios.post('/preprocess-zips', {
					db_column_name: DBColumnName,
					bando_id: this.bandoId,
					utenti_ids: this.compensi.map(c => c['id']),
					esiti_name: this.esitiNameByDBColumnName
				});
				this.loadingTotalZips = false;
				this.totalZips = response.data.total_zips;
				if (this.totalZips === 0) {
					this.zeroZips = true;
					this.downloadPdfsProgress = 100;
					return;
				}
				
				for (let i = 1; i <= this.totalZips; i++) {
					this.currentZip = i;
					
					if (this.cancelDownload) {
						console.log('download annullato');
						return;
					}
					
					await this.downloadZipPart(i, DBColumnName);
					this.downloadPdfsProgress = (i / this.totalZips) * 100;
				}
			}
			catch (error) {
				console.error('Error during download:', error);
			}
			finally {
				this.downloadingPdfs = false;
				if (this.cancelDownload) {
					this.downloadCancelled = true;
				}
				else {
					this.downloadCompleted = true;
				}
				
				this.downloadEnded = true;
			}
		},
		async downloadZipPart(zipIndex, DBColumnName) {
			try {
				const url = `/download-zip-part/${zipIndex}`;
				const response = await axios({
					url: url,
					method: 'GET',
					responseType: 'blob', // per gestire i file binari
					params: {
						bando_id: this.bandoId,
						// esiti_name: this.esitiNameByDBColumnName
					}
				});
				
				const nomeBando = this.bandi.find(bando => bando.id == this.bandoId).nome;
				const zipName = `PDF ${this.esitiNameByDBColumnName} - ${nomeBando}${this.totalZips !== 1 ? ` - Parte ${zipIndex}` : ''}.zip`;
				
				// Crea un link temporaneo per il download
				const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = urlBlob;
				link.setAttribute('download', zipName);
				document.body.appendChild(link);
				link.click();
				link.remove();
			}
			catch (error) {
				console.error(`Error downloading ZIP part ${zipIndex}:`, error);
			}
		},
		resetDownloadPdfs() {
			this.downloadEnded = false;
			this.downloadCompleted = false;
			this.cancelDownload = false;
			this.downloadCancelled = false;
			this.downloadPdfsDialog = false;
			this.downloadPdfsProgress = 0;
			this.currentZip = 0;
			this.zeroZips = false
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep {
	.compensi-data-table {
		background-color:#eeeeee;
		color: #434343 !important;
		& .v-data-table-header tr th {
			border-bottom: none !important;
			color: #fff !important;
			background-color: #6d94cd;
			//text-align: center !important;
			
		}
		
		tbody tr:nth-of-type(even) {
			background-color: rgba(109, 148, 205, .15);
		}
		
		td {
			//text-align: center;
			//font-weight: 500;
		}
	}
	
	.bando-select.v-select.v-input--is-dirty input {
		display: none;
	}
	
	.bando-select.v-select__selection {
		max-width: none;
	}
}


</style>